import type { RowData } from '@tanstack/react-table';
import { type ReactNode, useMemo } from 'react';
import { Cell, Row, Table } from '../tables';
import type { StrictColumnDef } from '../tanstack-table/column';

type PrintTableProperties<T extends RowData> = {
  items: T[];
  columns: StrictColumnDef<T>[];
  header?: ReactNode;
};

export function PrintTable<T extends RowData>({ items, columns, header }: PrintTableProperties<T>) {
  const croppedItems = useMemo(() => items.slice(0, 1000), [items]);

  return (
    <div>
      {header}
      {items.length > croppedItems.length && (
        <div className="bg-red-500 text-white text-center bold p-2 w-full">
          Only the first 1000 items are shown, consider using filters
        </div>
      )}
      <Table headings={columns.map((column) => column.id)}>
        {croppedItems.map((item, index) => (
          <Row key={index}>
            {columns.map((column, colIndex) => (
              <Cell key={colIndex}>{column.meta.toString(item)}</Cell>
            ))}
          </Row>
        ))}
      </Table>
    </div>
  );
}
